import React, {Component} from "react";
import {
    Panel,
    Modal,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    ButtonToolbar,
    OverlayTrigger,
    Tooltip
}                         from "react-bootstrap";
import {
    ToastContainer,
    toast
}                         from "react-toastify";
import                         "react-toastify/dist/ReactToastify.css";

import {
    IS_VALID,
    IS_UNDEFINED
}                         from "utils";

import CrudComponent      from "./../zynappse-crud";
import
MobileAppConfigSchema     from "./MobileAppConfigSchema";
import saveTrail          from '../../utils/saveTrail';

class MobileAppConfig extends Component {
    constructor (props) {
        super(props);

        this.state = {
            showModal: false,
            isLoadingAction: false,

            selectedData: null,
            formType: "",
            formTitle: "",
            formId: "",

            message: "",

            delayConfig_isLoading: false,
            delayConfig: null,
            delayConfig_value: 0,
            delayConfig_isSaving: false,
            delayConfig_showModal: false,

            timeoutConfig: null,
            timeoutConfig_value: 0,
            
            config_formType: '',
            config_formTitle: ''
        };

        this.saveData = this.saveData.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.accessible = this.accessible.bind(this);
        this.getNumberConfig = this.getNumberConfig.bind(this);
        this.saveNumberConfig = this.saveNumberConfig.bind(this);
    }

    componentDidMount () {
        this.getNumberConfig();
    }
    saveData () {
        let {
            selectedData,
            formType,
            message
        } = this.state;

        let isToActive = formType.toUpperCase() === "ACTIVATE" ? true : false;

        if (
            !isToActive &&
            (
                !IS_VALID(message) ||
                !IS_VALID(message.trim()) 
            )
        ) {
            toast.error("Message is required.");
        } else {
            this.setState({ isLoadingAction: true });

            selectedData.set("isActive", isToActive);

            if (!isToActive) {
                selectedData.set("message", message.trim());
            } else {
                selectedData.unset("message");
            }

            selectedData.save()
            .then((data) => {
                this.setState({
                    isLoadingAction: false,
                    showModal: false,

                    selectedData: null,
                    formType: "",
                    formTitle: "",
                    formId: "",

                    message: ""
                });

                let trailData = {
                    objectId: selectedData.id,
                    name: selectedData.get("name") || "",
                    key: selectedData.get("key") || "",
                    isActive: IS_VALID(selectedData.get("isActive")) ? selectedData.get("isActive").toString() : "false"
                };

                if (!isToActive) {
                    trailData.message = message.trim();
                }

                saveTrail("UPDATE", trailData);
            })
            .catch((err) => {
                console.log("error: ", err);
                
                this.setState({
                    isLoadingAction: false,
                    showModal: false,

                    selectedData: null,
                    formType: "",
                    formTitle: "",
                    formId: "",

                    message: ""
                });
            });
        }
    }

    renderModalButton () {
        let {
            isLoadingAction,

            formType
        } = this.state;

        return [
            <Button
                bsStyle={formType.toUpperCase() === "ACTIVATE" ? "success" : "danger"}
                disabled={isLoadingAction}
                onClick={() => {
                    this.saveData();
                }}
            >
                {formType}
            </Button>,
            <Button
                disabled={isLoadingAction}
                onClick={() => {
                    if (!isLoadingAction) {
                        this.setState({
                            showModal: false,

                            selectedData: null,
                            formType: "",
                            formTitle: "",
                            formId: "",

                            message: ""
                        });
                    }
                }}
            >
                CLOSE
            </Button>
        ]
    }

    accessible (actionType) {
        let {
            access
        } = this.props.accessjson;

        if (access.length !== 0) {
            var currentPath = window.location.pathname,
                    index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
                    actions = [];

            if (access[index]) {
                actions = access[index].actions
            }

            if (actions.length != 0) {
                if (actions.indexOf(actionType.toUpperCase()) === -1) {
                    return 'none';
                } else {
                    return '';
                }
            } else {
                return 'none';
            }
        } else {
            return 'none';
        }
    }

    getNumberConfig () {
        this.setState({
            delayConfig_isLoading: true
        });

        let numberConfigQuery = new Parse.Query("NumberConfig");

        numberConfigQuery
        .containedIn("name", [ 'QR_CLOCK_IN_DELAY', 'QR_CLOCK_IN_TIMEOUT' ])
        .descending("createdAt");

        numberConfigQuery.find()
        .then((datas) => {
            let stateToUpdate = {
                delayConfig_isLoading: false
            };

            const NUMBER_KEY = {
                QR_CLOCK_IN_DELAY: 'delayConfig',
                QR_CLOCK_IN_TIMEOUT: 'timeoutConfig'
            };

            for (const data of datas) {
                if (
                    NUMBER_KEY[data.get('name')]
                ) {
                    stateToUpdate[NUMBER_KEY[data.get('name')] + ''] = data;
                    stateToUpdate[NUMBER_KEY[data.get('name')] + '_value'] = data.get("value") || 0;
                }
            }
            

            this.setState(stateToUpdate);
        })
        .catch((err) => {
            console.log("getNumberConfig error");
            console.log(err);

            this.setState({
                delayConfig_isLoading: false
            });
        });
    }

    saveNumberConfig () {
        let {
            delayConfig,
            delayConfig_value,

            timeoutConfig,
            timeoutConfig_value,
            
            config_formType
        } = this.state;

        let config = delayConfig,
            value = delayConfig_value,
            name = 'Delay';

        if (config_formType === 'TIMEOUT') {
            config = timeoutConfig;
            value = timeoutConfig_value;
            name = 'Timeout';
        }

        value = parseInt(value) || 0;

        if (
            value <= 0
        ) {
            return toast.error(name + " should not be zero.");
        }
        
        this.setState({ delayConfig_isSaving: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(config)) {
              resolve(config);
            } else {
              let query = new Parse.Query("NumberConfig");
      
              query
              .equalTo("name", `QR_CLOCK_IN_${config_formType}`)
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((numberConfig) => {
            if (IS_UNDEFINED(numberConfig)) {
                numberConfig = new Parse.Object("NumberConfig");

                numberConfig.set("name", `QR_CLOCK_IN_${config_formType}`);
            }

            numberConfig
            .set("value", value*1000);

            return numberConfig.save();
        })
        .then((numberConfig) => {
            let stateToUpdate = {
                delayConfig_isSaving: false,
                delayConfig_showModal: false,
                delayConfig: numberConfig,
                delayConfig_value: value
            };

            if (config_formType === 'TIMEOUT') {
                stateToUpdate.timeoutConfig = numberConfig;
                stateToUpdate.timeoutConfig_value = value;

                delete stateToUpdate.delayConfig;
                delete stateToUpdate.delayConfig_value;
            }
        
            this.setState(stateToUpdate);

            saveTrail(
                "UPDATE",
                {
                    ['QR Clock In ' + name]: value
                }
            );
        })
        .catch((err) => {
            console.log("saveNumberConfig error");
            console.log(err);

            this.setState({
                isSaving: false,
                showModalConfig: false
            });
        });
    }

    render () {
        let {
            showModal,
            isLoadingAction,

            selectedData,
            formType,
            formTitle,

            message,

            delayConfig_isLoading,
            delayConfig,
            delayConfig_value,
            delayConfig_isSaving,
            delayConfig_showModal,

            timeoutConfig,
            timeoutConfig_value,
            
            config_formType,
            config_formTitle
        } = this.state;

        let {
            access
        } = this.props.accessjson;

        let crudProps = {
            schema: MobileAppConfigSchema,
            access: access,
            customItems: [
                {
                    columnName: "isActive",
                    render: ({ value, column, object }) => {
                        let name = IS_VALID(object.get("name")) ? object.get("name") : "",
                            key = IS_VALID(object.get("key")) ? object.get("key") : "",
                            isActive = IS_VALID(object.get("isActive")) ? object.get("isActive") : false;
                        
                        let renderValue = "";

                        let isUpdateAccessible = this.accessible("UPDATE") === "";

                        renderValue = (
                            <ButtonToolbar>
                            <Button
                                style={(!isUpdateAccessible) ? { cursor: "not-allowed" } : null}
                                disabled={!isUpdateAccessible}
                                bsStyle={isActive ? "success" : "danger"}
                                onClick={() => {
                                    if (
                                        !isUpdateAccessible
                                    ) {
                                        return;
                                    }

                                    this.setState({
                                        showModal: true,
                                        selectedData: object,
                                        formType: isActive ? "DEACTIVATE" : "ACTIVATE",
                                        formTitle: (isActive ? "DE" : "") + "ACTIVATE " +  name
                                    })
                                }}
                            >
                                {isActive ? "ACTIVE" : "INACTIVE"}
                            </Button>
                            {key === 'GENERATE_QR_CLOCK_IN' ? (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="delay">
                                            Delay
                                        </Tooltip>
                                    }
                                >
                                    <Button
                                        style={(!isUpdateAccessible) ? { cursor: "not-allowed" } : null}
                                        disabled={delayConfig_isLoading || !isUpdateAccessible}
                                        onClick={() => {

                                            if (
                                            !isUpdateAccessible
                                            ) {
                                                return;
                                            }

                                            this.setState({
                                                delayConfig_showModal: true,
                                                delayConfig_value: (delayConfig && delayConfig.get("value") || 0)/1000,
                                                config_formType: 'DELAY',
                                                config_formTitle: 'QR CLOCK IN RENEW DELAY'
                                            });
                                        }}
                                    >
                                        {delayConfig_isLoading ? (
                                            <i className="fa fa-spinner fa-spin"/>
                                        ) : (
                                            `${delayConfig ? (delayConfig.get("value") || 0)/1000 : 0}s`
                                        )}
                                    </Button>
                                </OverlayTrigger>
                            ) : ''}
                            {key === 'GENERATE_QR_CLOCK_IN' ? (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="delay">
                                            Timeout
                                        </Tooltip>
                                    }
                                >
                                    <Button
                                        style={(!isUpdateAccessible) ? { cursor: "not-allowed" } : null}
                                        disabled={delayConfig_isLoading || !isUpdateAccessible}
                                        onClick={() => {

                                            if (
                                            !isUpdateAccessible
                                            ) {
                                                return;
                                            }

                                            this.setState({
                                                delayConfig_showModal: true,
                                                timeoutConfig_value: (timeoutConfig && timeoutConfig.get("value") || 0)/1000,
                                                config_formType: 'TIMEOUT',
                                                config_formTitle: 'QR CLOCK IN IDLE TIMEOUT'
                                            });
                                        }}
                                    >
                                        {delayConfig_isLoading ? (
                                            <i className="fa fa-spinner fa-spin"/>
                                        ) : (
                                            `${timeoutConfig ? (timeoutConfig.get("value") || 0)/1000 : 0}s`
                                        )}
                                    </Button>
                                </OverlayTrigger>
                            ) : ''}
                            </ButtonToolbar>
                        );

                        return renderValue;
                    }
                }
            ]
        };

        return (
            <div>
                <Panel>
                    <Panel.Heading
                        style={{
                            backgroundColor: '#D1282F',
                            color: 'white'
                        }}
                        >
                        <h4>MOBILE APP CONFIG</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent
                            {...crudProps}
                        />
                    </Panel.Body>
                </Panel>
                <Modal
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            this.setState({
                                showModal: false,

                                selectedData: null,
                                formType: "",
                                formTitle: "",
                                formId: "",

                                message: ""
                            });
                        }
                    }}
                >
                    <Modal.Header closeButton>{formTitle}</Modal.Header>
                    <Modal.Body>
                        {formType.toUpperCase() === "ACTIVATE" ? (
                            "Are you sure you want to activate " + (IS_VALID(selectedData) && IS_VALID(selectedData.get("name")) ? selectedData.get("name") : "") + "?"
                        ) : (
                            <FormGroup>
                                <ControlLabel>Message</ControlLabel>
                                <FormControl
                                    componentClass="textarea"
                                    value={message}
                                    onChange={(e) => {
                                        this.setState({ message: e.target.value });
                                    }}
                                />
                            </FormGroup>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={delayConfig_showModal}
                    onHide={() => {
                        if (!delayConfig_isSaving) {
                            this.setState({
                                delayConfig_showModal: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>{config_formTitle}</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup>
                            <ControlLabel>{config_formType.charAt(0) + config_formType.slice(1).toLowerCase()} (seconds)</ControlLabel>
                            <FormControl
                                value={config_formType === 'DELAY' ? delayConfig_value : timeoutConfig_value}
                                onChange={(e) => {
                                    let key = config_formType === 'DELAY' ? 'delayConfig_value' : 'timeoutConfig_value';

                                    this.setState({
                                        [key]: e.target.value.replace(/[^0-9]/g, "")
                                    })
                                }}
                            />
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle="primary"
                            disabled={delayConfig_isSaving}
                            onClick={() => this.saveNumberConfig()}
                        >
                            SAVE
                        </Button>
                        <Button
                            disabled={delayConfig_isSaving}
                            onClick={() => {
                                if (!delayConfig_isSaving) {
                                    this.setState({
                                        delayConfig_showModal: false
                                    });
                                }
                            }}
                        >
                            CLOSE
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer/>
            </div>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';

function mapStateToProps(state) {
	var {
		accessjson
	} = state;

	const props = {
		accessjson
	};
	return props;
}

export default connect(mapStateToProps)(MobileAppConfig);


// WEBPACK FOOTER //
// ./components/MobileAppConfig/index.js